export async function sendEmail(sendTo, name, code, template) {
    const url = 'https://mailer.echeide.com/service/send/';
    const sendToEmail = [sendTo, 'info@echeide.com', 'cultura@losrealejos.es'];
    // const url = 'http://localhost:8700/send/';
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            templateName: 'El-Genio-de-los-realejos-fin-de-juego',
            to: sendToEmail,
            cc: ['cultura@losrealejos.es'],
            cco: ['jorge.reina@echeide.com', 'felipelorenzo@echeide.com'],
            data: {
                playerName: name,
                code: code
            }
        })
    });
    if (!response.ok) {
        throw new Error('Ha ocurrido un error al obtener milestones.');
    }
}
